
    import * as React from 'react';

    const Next24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" style={svgStyle}><path d="M13.613 5.715L14.35 5 22 12l-7.65 7-.737-.715 6.325-5.787H2v-.996h17.938z" /></svg>
        </div>
      );
    };

    Next24.displayName = 'Next24';

    export default Next24;
  